module.exports = __webpack_public_path__ + "img/sort／web／Puzzle@2x.7c41000f.png";